export default __webpack_public_path__ + "static/media/volkihar-background.d1d1d6d3.jpg";